<template>
  <div class="view-page">
    <title-bar title="Perfil empresa" />

    <div class="cp-body">

      <section class="cp-section">
        <div class="cp-section__head">
          <h2 class="cp-section__title">Datos legales</h2>
          <p class="cp-section__desc">Información de identificación fiscal de la empresa.</p>
        </div>
        <div class="cp-section__content">
          <div class="cp-field">
            <span class="cp-field__label">Nombre comercial</span>
            <span class="cp-field__value">{{ profile.name || '—' }}</span>
          </div>
          <div class="cp-divider" />
          <div class="cp-field">
            <span class="cp-field__label">Nombre legal</span>
            <span class="cp-field__value">{{ profile.legalName || '—' }}</span>
          </div>
          <div class="cp-divider" />
          <div class="cp-field">
            <span class="cp-field__label">RFC</span>
            <span class="cp-field__value">{{ profile.identity || '—' }}</span>
          </div>
        </div>
      </section>

      <section class="cp-section">
        <div class="cp-section__head">
          <h2 class="cp-section__title">Información adicional</h2>
          <p class="cp-section__desc">Datos de ubicación y registro en la plataforma.</p>
        </div>
        <div class="cp-section__content">
          <div class="cp-field">
            <span class="cp-field__label">Código postal</span>
            <span class="cp-field__value">{{ profile.zipCode || '—' }}</span>
          </div>
          <div class="cp-divider" />
          <div class="cp-field">
            <span class="cp-field__label">Fecha de registro</span>
            <span class="cp-field__value">{{ formatDate(profile.createdAt, 'DD MMMM YYYY') || '—' }}</span>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '../../mixins/formats'
export default {
  components: {
    TitleBar: () => import('@/components/ui/TitleBar.vue')
  },
  mixins: [mixins],
  data () {
    return {
      loading: true
    }
  },
  methods: {
    ...mapActions([])
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: (state) => state.financialCompany.financialCompany
    })
  }
}
</script>

<style lang="scss" scoped>
.cp-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cp-section {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 1.5rem;
  background: #ffffff;
  border: 1px solid #eef0f3;
  border-radius: 12px;
  padding: 1.75rem 2rem;
}

.cp-section__head {
  padding-right: 1rem;
  border-right: 1px solid #eef0f3;
}

.cp-section__title {
  font-size: 14px;
  font-weight: 600;
  color: #1a2233;
  margin: 0 0 6px;
}

.cp-section__desc {
  font-size: 12px;
  color: #9aa5b4;
  line-height: 1.5;
  margin: 0;
}

.cp-section__content {
  display: flex;
  flex-direction: column;
}

.cp-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0;
  min-height: 52px;

  &__label {
    font-size: 12px;
    font-weight: 500;
    color: #9aa5b4;
    min-width: 160px;
  }

  &__value {
    font-size: 13px;
    font-weight: 500;
    color: #2d3748;
  }
}

.cp-divider {
  height: 1px;
  background-color: #eef0f3;
}
</style>
